export const signInInitialState = {
  email: '',
  password: '',
  isValidEmail: true,
  isValidPassword: true,
  isSubmitting: false,

  isRequestResetPasswordDialogOpen: false,
  isSendingResetPasswordRequest: false,
  requestResetPasswordEmail: '',
  isRequestResetPasswordEmailValid: true
}

export type SignInState = typeof signInInitialState
